module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product6-ef0655abdf9f47c5ad9b95be9fb8a862.jpg";